var _rect, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgFaceshape = _ref => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 84 84",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "a",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 84,
    height: 84
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 84,
    height: 84,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#a)",
    fill: "currentColor"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M42.502 58.984c-6.506 0-10.665-3.693-11.48-10.157-2.018-.865-3.25-2.4-3.327-4.182-.066-1.534.748-2.942 2.154-3.792-.479-4.522.534-8.379 2.945-11.18 2.314-2.689 5.762-4.172 9.708-4.172 3.945 0 7.393 1.482 9.707 4.172 2.41 2.801 3.424 6.658 2.945 11.182 1.408.851 2.22 2.26 2.154 3.792-.076 1.781-1.309 3.317-3.327 4.182-.815 6.462-4.974 10.156-11.48 10.156v-.001Zm0-31.828c-3.47 0-6.483 1.281-8.483 3.606-2.194 2.55-3.054 6.163-2.487 10.45a.829.829 0 0 1-.473.863c-1.117.512-1.783 1.469-1.738 2.498.052 1.22 1.07 2.296 2.724 2.882.299.105.51.378.541.7.574 5.916 4.095 9.174 9.918 9.174 5.822 0 9.343-3.258 9.917-9.175a.822.822 0 0 1 .541-.7c1.652-.585 2.67-1.663 2.724-2.88.044-1.029-.621-1.987-1.74-2.499a.83.83 0 0 1-.473-.864c.568-4.285-.293-7.898-2.486-10.45-2-2.325-5.014-3.605-8.483-3.605h-.002Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m26.403 34.516-7.727 7.727 7.727 7.728V34.516Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m50.228 24.213-7.727-7.727-7.727 7.727h15.454Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.773 60.273 42.5 68l7.728-7.727H34.773Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m58.6 34.516 7.726 7.727-7.727 7.728V34.516Z"
  }))));
};
export { SvgFaceshape as ReactComponent };